import type { SanitizeUserInputOptions } from '~/utils/sanitize-user-input';
import { forwardRef } from 'react';
import { sanitizeUserInput } from '~/utils/sanitize-user-input';
import { ImageExpander } from '~/features/common';
import { FormattedRichTextContent } from './RichTextContent.styles';

export interface RichTextContentProps {
  children: string | null | undefined;
  sanitizeOptions?: SanitizeUserInputOptions;
  customElementStyles?: string;
}

export const RichTextContent = forwardRef<HTMLDivElement, RichTextContentProps>(
  ({ children, sanitizeOptions = { allowSafeTags: true }, customElementStyles }, forwardedRef) => (
    <ImageExpander>
      <FormattedRichTextContent
        ref={forwardedRef}
        $customStyles={customElementStyles}
        dangerouslySetInnerHTML={{
          __html: sanitizeUserInput(children, sanitizeOptions),
        }}
      />
    </ImageExpander>
  ),
);
